module.exports = __webpack_public_path__ + "static/media/arrow_white svg.8bd7a485.svg";